export const FETCH_HELP_ARTICLES = 'app/HelpCenter/FETCH_HELP_ARTICLES'
export const FETCH_HELP_ARTICLES_SUCCESS =
  'app/HelpCenter/FETCH_HELP_ARTICLES_SUCCESS'
export const FETCH_HELP_ARTICLES_ERROR =
  'app/HelpCenter/FETCH_HELP_ARTICLES_ERROR'
